import React from 'react'
import styled from 'styled-components'
import Text from '../../utils/Text'
import media from '../../utils/media'
import Title from './Title'
import FootNote from './FootNote'

const Container = styled.div`
  margin: 92px auto 100px;
  ${media.mobileL`
    margin: 23px auto 18px;
    text-align: left;
  `}
  .section-title {
    text-align: center;
  }
  ${media.mobileL`
    .result-footnote {
      margin-bottom: 0;
      margin-top: 10px;
    }
  `}
`

const Subtitle = styled.div`
  margin: 50px auto;
  text-align: center;
  span {
    font-size: 32px;
    line-height: 1.22;
  }
  ${media.mobileL`
    margin: 30px auto;
    span {
      font-size: 25px;
    }
  `}
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  ${media.mobileL`
    flex-direction: column;
  `}
`

const Steps = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  max-width: 321px;
  text-align: center;
  ${media.mobileL`
    max-width: 100%;
    flex-direction: row;
    text-align: left;
    padding-bottom: 27px;
  `}
`

const Num = styled.div`
  margin-bottom: 18px;
  p {
    color: #ffae45;
    font-family: Muli;
    font-size: 32px;
    line-height: 0.92;
    font-weight: bold;
  }
  ${media.mobileL`
    margin-right: 25px;
  `}
`

const TextContainer = styled.div`
  span {
    font-family: Muli;
    font-weight: normal;
    font-size: 16px;
    line-height: 1.44;
  }
`

export default function Result({ config, score }) {
  const { title, subtitle, items, footnote } = config

  return (
    <>
      {score && (
        <Container className="col">
          <Title title={`${title}.${score}`} />
          <Subtitle>
            <Text id={`${subtitle}.${score}`} />
          </Subtitle>
          <Wrapper>
            {items.map(el => {
              return (
                <Steps key={el.text}>
                  <Num>
                    <Text id={el.num} markdown />
                  </Num>
                  <TextContainer>
                    <Text id={`${el.text}.${score}`} markdown />
                  </TextContainer>
                </Steps>
              )
            })}
          </Wrapper>
          {footnote && (
            <FootNote
              footnote={footnote}
              className="result-footnote"
            />
          )}
        </Container>
      )}
    </>
  )
}
